/**
 * Enable modal popup when the user requests a callback and the callback request is queued
 */
export const HELP_CENTER_PHONE_CALLBACK_QUEUE_MODAL_241009 =
  'HELP_CENTER_PHONE_CALLBACK_QUEUE_MODAL_241009';
